module.exports = __webpack_public_path__ + "img/7.42b6bc4d.jpg";